
import React from 'react';

import PropTypes from 'prop-types';

import _ from 'underscore';
import { PidlUtilShape } from '../shapes';
import { ResourceTypes } from '../consts';
import type { RiskData, ValidatorPidlFormProps } from '../types';

export class ValidatorPidlForm extends React.Component<ValidatorPidlFormProps> {
  static propTypes = {
    pidlInstance: PropTypes.shape({
      handleChallenge: PropTypes.func.isRequired,
    }),
    pidlUtil: PidlUtilShape.isRequired,
    piData: PropTypes.shape({
      Market: PropTypes.string,
      CtpPiId: PropTypes.number,
    }).isRequired,
    pidlFormId: PropTypes.string.isRequired,
  };

  static defaultProps: Partial<ValidatorPidlFormProps> = {

    pidlInstance: null,
  };

  componentDidUpdate() {
    if (this.props.pidlInstance) {
      const resourceInfo = {
        resourceType: ResourceTypes.PaymentInstrument,
        id: this.props.piData.CtpPiId,
        parameters: _.extend(
          {
            country: this.props.piData.Market,
          },
          this.props.pidlUtil.pidlDocParameters
        ),
      };

      this.props.pidlUtil.logger.setPidlOption('Market', this.props.piData.Market);


      this.props.pidlUtil.getRiskData().then((riskData: RiskData) => {
        this.props.pidlUtil.logger.start('renderPidl');
        this.props.pidlInstance.handleChallenge(resourceInfo, riskData);
      });
    }
  }

  render() {
    return (
      <div className="validator-pidl-form-container">
        <div id={this.props.pidlFormId} />
      </div>
    );
  }
}
